import React from "react";
import { BackgroundColorProps, FlexboxProps, LayoutProps, SpaceProps } from "styled-system";
import styled from "styled-components";
import Box from "../Box";

type CardProps = {
  children: React.ReactNode;
  className?: string;
} & LayoutProps &
  FlexboxProps &
  SpaceProps &
  BackgroundColorProps;

const StyledCardBox = styled(Box)`
  @media (max-height: 560px) and (orientation: landscape) {
    padding: 6px !important;
    margin-bottom: 4px !important;
  }
`;

const Card = ({ children, className, ...rest }: CardProps) => {
  return (
    <StyledCardBox
      bg="white"
      borderRadius={1}
      p={[2, 3]}
      mb={1}
      display="flex"
      flexDirection="column"
      minWidth={"10px"}
      className={className}
      {...rest}
    >
      {children}
    </StyledCardBox>
  );
};

export default Card;
